
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Stack,
  Rating,
  Button,
} from "@mui/material";

/* DATE FORMAT */
const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  return `${String(d.getDate()).padStart(2, "0")}/${String(
    d.getMonth() + 1
  ).padStart(2, "0")}/${d.getFullYear()}`;
};

/* SINGLE REVIEW CARD */
function ReviewCard({ r }) {
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setOverflow(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [expanded, r.review]);

  return (
 
    <Paper
  elevation={0}
  sx={{
    p: 2,
    borderRadius: 3,
    border: "1px solid #e5e5e5",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
    minWidth: 0,
    overflow: "hidden",
  }}
>

      {/* TOP */}
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Stack direction="row" spacing={2}>
          <Avatar
            src={r.user?.avatar}
            sx={{ width: 46, height: 46 }}
          />

          <Box>
            <Typography fontWeight={600} fontSize={14}>
              {r.user?.name}
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontSize={12} color="text.secondary">
                {r.rating}
              </Typography>
              <Rating
                value={Number(r.rating)}
                precision={0.5}
                readOnly
                size="small"
              />
            </Stack>
          </Box>
        </Stack>

        <Typography fontSize={12} color="text.secondary">
          {formatDate(r.created_at)}
        </Typography>
      </Stack>

  

      <Typography
  ref={textRef}
  mt={1.5}
  fontSize={13}
  color="#444"
  lineHeight={1.6}
  sx={{
    display: "-webkit-box",
    WebkitLineClamp: expanded ? "unset" : 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordBreak: "break-word",
   
  }}
>
  {r.review}
</Typography>

      {/* SHOW MORE */}
      {(overflow || expanded) && (
        <Button
          size="small"
          onClick={() => setExpanded(!expanded)}
          sx={{ mt: 0.5, textTransform: "none", alignSelf: "flex-start" }}
        >
          {expanded ? "Show less" : "Show more"}
        </Button>
      )}
    </Paper>
  );
}

/* MAIN COMPONENT */
export default function ReviewRating({ reviews = [] }) {
  if (!reviews.length) {
    return (
      <Box py={4} textAlign="center">
        <Typography fontWeight={600}>
          No reviews yet
        </Typography>
        <Typography fontSize={13} color="text.secondary">
          Be the first to review this vendor
        </Typography>
      </Box>
    );
  }

  return (
    <Box width="100%">
      {/* HEADING */}
      <Typography fontWeight={700} fontSize={{ xs: 18, md: 22 }} mb={2}>
        Reviews{" "}
        <Typography component="span" fontSize={13} color="text.secondary">
         ({reviews.length} reviews)
        </Typography>
      </Typography>

      {/* GRID LAYOUT */}
    <Box
  sx={{
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
    },
    minWidth: 0,    
  }}
>

        {reviews.map((r) => (
          <ReviewCard key={r.id} r={r} />
        ))}
      </Box>
    </Box>
  );
}
